import { IconInformation, IconWarning } from '../../../../assets/DesignSystem/SVGComponents';
import { NudosAddressSearchBar, NudosButton, NudosPhoneInput, NudosTextInput } from '../../../NudosComponents';
import { NoPicture } from '../../../../assets/images/orders';
import { getAddressErrorText, isPhoneValid } from '../../../../utils/formValidations';
import { useEffect, useState } from 'react';
import { ICountryDetail } from '../../../../types/countries';
import { formatZipCode, getIsInvalidZipCode, invalidZipCodeText } from '../../../../utils/productDefinitions';
import { IcityDetails } from '../../../../types/cities.types';
import NudosCityDropdown from '../../NudosCityDropdown/NudosCityDropdown';
import { DTOupdateEmployeeData, IShipmentData, SHIPMENT_PLATFORM } from '../../../../types/orders';
import { countriesList as getCountriesList } from '../../../../services/countriesList';
import { IaddressFromGoogleMaps } from '../../../../types/global';
import { updateShipmentInformation } from '../../../../services/orders';
import errorMessage from '../../../../utils/errorMessage';

import { displaySuccessNotification } from '../../../../utils/displayNudosStandardNotifications';
import './NudosEditUserAddressModal.scss';

const NudosEditUserAddressModal = ({
  closeModalCallback,
  shipInfo,
  updateWithoutLoaders
}: {
  closeModalCallback: () => void;
  shipInfo: IShipmentData;
  updateWithoutLoaders: () => void;
}) => {
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [wasEdited, setWasEdited] = useState<boolean>(false);

  const blockedByDeliveryProcess = shipInfo.statusId === 4;

  const [phoneCountry, setPhoneCountry] = useState<ICountryDetail>();
  const [zipCode, setZipCode] = useState<string>();
  const [city, setCity] = useState<IcityDetails>();

  const [userAddress, setUserAddress] = useState<string>();
  const [fullAddress, setFullAddress] = useState<IaddressFromGoogleMaps>();

  const [countriesList, setCountriesList] = useState<ICountryDetail[]>();
  const [selectedCountry, setSelectedCountry] = useState<ICountryDetail>();
  const [personalDocument, setPersonalDocument] = useState<string>();
  const [loadingUpdateData, setLoadingUpdateData] = useState(false);
  const [loadingCountries, setLoadingCountries] = useState<boolean>(true);
  const [additionalReferences, setAdditionalReferences] = useState<string>();

  const locationCountry = countriesList?.find(country => country?.code === shipInfo.country.code);
  const locationPhone = countriesList?.find(
    country => Number(country?.phoneCode) === Number(shipInfo?.userInfo?.phoneData?.phoneCode)
  );

  const employeeId = shipInfo?.receiverInfo?.receiverIdDocument;
  const employeeName = `${shipInfo?.receiverInfo?.receiverName}`;
  const employeeCountryFlag = shipInfo?.country?.flag;

  const employeePhotoProfile = shipInfo?.userInfo?.photoProfile;
  const cleanProfilePictureUrl = employeePhotoProfile ? `${employeePhotoProfile?.replaceAll(' ', '%20')}` : NoPicture;
  const profilePictureUrl = `url("${cleanProfilePictureUrl}")`;
  const additionalReferencesErrorText = !additionalReferences && userAddress ? 'Completa las indicaciones' : '';
  const alertText = 'Al actualizar la información, esta se guardará en el perfil del empleado';
  const subtitleModal = 'Agrega o valida la información del empleado para el envío';

  const addressErrorText = getAddressErrorText(
    selectedCountry?.code,
    selectedCountry?.name,
    fullAddress?.country || undefined
  );

  const cityDetails: IcityDetails = {
    id: shipInfo?.cityId,
    name: shipInfo.city,
    country: selectedCountry
  };

  const getPhoneError = () => {
    if (phoneNumber && phoneNumber.length > 3 && !isPhoneValid(phoneNumber)) return 'asdasdasd';
    return undefined;
  };

  const isDeactivated = loadingUpdateData;

  const disableUpdateButton =
    loadingUpdateData ||
    !!getPhoneError() ||
    !!addressErrorText ||
    !phoneCountry ||
    !phoneNumber ||
    !zipCode ||
    !city ||
    !city.id ||
    !additionalReferences ||
    !wasEdited;

  const setInitialData = () => {
    if (loadingCountries) return;
    if (!personalDocument) setPersonalDocument(employeeId || undefined);
    if (!phoneNumber) setPhoneNumber(shipInfo?.userInfo?.phoneData?.phone);
    if (!phoneCountry) setPhoneCountry(locationPhone);
    if (!zipCode) setZipCode(shipInfo.zipCode || undefined);
    if (!city) setCity(cityDetails);
    if (!additionalReferences) setAdditionalReferences(shipInfo?.additionalReferences || undefined);
    if (!selectedCountry) setSelectedCountry(locationCountry);
    if (!userAddress) setUserAddress(shipInfo?.deliveryAddress || undefined);
  };

  const getCountries = async () => {
    try {
      setLoadingCountries(true);
      const dataCountries = await getCountriesList();
      setCountriesList(dataCountries);
    } catch {
    } finally {
      setLoadingCountries(false);
    }
  };

  const uppdateAddressData = async () => {
    const addressUpdateBody: DTOupdateEmployeeData = {
      firstName: shipInfo?.userInfo?.firstName || '',
      lastName: shipInfo?.userInfo?.lastName || '',
      countryId: Number(selectedCountry?.id),
      countryPhoneId: Number(phoneCountry?.id),
      phone: phoneNumber,
      city: `${city?.name}`,
      cityId: Number(city?.id),
      personalId: personalDocument,
      address: {
        additionalReferences: additionalReferences,
        address: fullAddress ? fullAddress.address : undefined,
        city: `${city?.name}`,
        cityId: Number(city?.id),
        coordinates: fullAddress ? fullAddress.coordinates : undefined,
        country: selectedCountry?.code,
        zipCode: zipCode
      }
    };
    setLoadingUpdateData(true);
    try {
      await updateShipmentInformation(
        shipInfo.shipmentGroupId,
        { onlyOrder: false, userInfo: addressUpdateBody, platform: SHIPMENT_PLATFORM.SOGA },
        undefined,
        Number(shipInfo?.userInfo?.userId)
      );
      await updateWithoutLoaders();
      closeModalCallback();
      displaySuccessNotification({
        customJSXMessage: <>Actualizaste la información del envío con éxito</>
      });
    } catch (error) {
      errorMessage();
    } finally {
      setLoadingUpdateData(false);
    }
  };

  const updateAddress = (selectedAddress: IaddressFromGoogleMaps) => {
    setUserAddress(selectedAddress?.address || undefined);
    setFullAddress(selectedAddress);
  };

  useEffect(() => {
    setInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipInfo, loadingCountries]);

  useEffect(() => {
    getCountries();
  }, []);
  return (
    <div className="nudosEditDirectionModalContent">
      <div className="subtitleModal">{subtitleModal}</div>
      <div className="employeeHeaderContainer">
        <div className="imgContainer">
          <div className="imgStyle" style={{ backgroundImage: profilePictureUrl }} />
        </div>
        <div className="employeeName">{employeeName}</div>
        <div className="valueFlag" style={{ backgroundImage: `url(${employeeCountryFlag})` }} />
      </div>
      <div className="inputsContainer">
        <NudosTextInput
          label="Doc. de identidad (opcional)"
          isFilled={!!personalDocument}
          placeholder="Doc. de identificación"
          handleChange={e => {
            setPersonalDocument(e);
            setWasEdited(true);
          }}
          componentSize="small"
          defaultValue={personalDocument}
          showSkeletonLoader={loadingCountries}
          isDeactivated={isDeactivated || blockedByDeliveryProcess}
        />
        <NudosPhoneInput
          label="Número de teléfono"
          handleCountryPhoneChange={setPhoneCountry}
          handlePhoneChange={setPhoneNumber}
          defaultPhoneNumber={phoneNumber}
          defaultCountryData={phoneCountry}
          personalClass="phoneInputStyles"
          placeholder="Número de teléfono"
          errorText={getPhoneError()}
          countriesList={countriesList || []}
          isDisabled={loadingUpdateData}
          showSkeletonLoader={loadingCountries}
          simpleChangeOfValues={() => {
            setWasEdited(true);
          }}
        />
        <NudosTextInput
          label={'CP*'}
          isFilled={!!zipCode}
          errorText={getIsInvalidZipCode(zipCode) ? invalidZipCodeText : undefined}
          placeholder={'Zip/ CP'}
          handleBlur={newZipCode => setZipCode(formatZipCode(newZipCode))}
          handleChange={e => {
            setZipCode(e);
            setWasEdited(true);
          }}
          defaultValue={(zipCode && formatZipCode(zipCode)) || undefined}
          componentSize="extraSmall"
          showSkeletonLoader={loadingCountries}
          isDeactivated={loadingUpdateData || blockedByDeliveryProcess}
        />
        <NudosCityDropdown
          countryId={shipInfo.country.id}
          countryCode={shipInfo?.country?.code}
          currentValue={city}
          componentSize="small"
          isDeactivated={loadingUpdateData || blockedByDeliveryProcess}
          showSkeletonLoader={loadingCountries}
          updateCurrentValueCallback={e => {
            setWasEdited(true);
            setCity(e);
          }}
          errorText={!city?.id ? 'Corrige la ciudad para continuar con el servicio' : undefined}
          sortAlphabetically
        />
        <NudosTextInput
          label="Indicaciones"
          isFilled={!!additionalReferences}
          errorText={additionalReferencesErrorText}
          placeholder="Apartamento, Piso, Bloque."
          componentSize="small"
          handleChange={(inputText: string) => {
            setAdditionalReferences(inputText);
            setWasEdited(true);
          }}
          defaultValue={additionalReferences}
          isDeactivated={isDeactivated || blockedByDeliveryProcess}
          showSkeletonLoader={loadingCountries}
        />
        <NudosAddressSearchBar
          label="Dirección"
          errorText={addressErrorText}
          regionBias={shipInfo.country.code}
          isDisabled={isDeactivated || blockedByDeliveryProcess}
          componentSize="extraLarge"
          showSkeletonLoader={loadingCountries}
          customPlaceholder="Busca la dirección escribiendo la ciudad y el país"
          handleAddressSelection={selectedAddress => {
            updateAddress(selectedAddress);
            setWasEdited(true);
          }}
          defaultValueAddressName={userAddress}
          didntFindAddressTooltipTopPosition={56 + (addressErrorText ? 10 : 0)}
          didntFindAddressTooltipRightPosition={0}
        />
      </div>
      <div className="alertModal">
        <IconWarning />
        {alertText}
      </div>

      {blockedByDeliveryProcess && (
        <div className="cancelLsContainer">
          <IconInformation className="IconInformation" />
          <div className="cancelLsTextContainer">
            <div>No puedes editar esta orden porque está en proceso de entrega. </div>
          </div>
        </div>
      )}
      <NudosButton
        buttonText="Actualizar datos"
        handleClick={() => {
          uppdateAddressData();
        }}
        componentSize="medium"
        customClassName="saveButton"
        isButtonLoading={loadingUpdateData}
        isButtonDisabled={disableUpdateButton || loadingCountries}
      />
    </div>
  );
};

export default NudosEditUserAddressModal;
